import { useAuthCookies } from '@/hooks/useAuthCookies';
import { cn } from '@/utils/cn';
import { useRouter } from 'next/router';

const links = [
  {
    label: 'Livescore',
    url: '/livescore',
  },
  {
    label: 'Centrum Ulubionych',
    url: '/livescore/favorite-center',
  },
];

const LivescoreSidebarTabs = () => {
  const { token } = useAuthCookies();

  const router = useRouter();

  if (!token) return null;
  return (
    <div className="w-full flex items-center gap-4">
      {links.map(({ label, url }) => (
        <a
          href={url}
          key={label}
          className={cn(
            'font-bold rounded-lg border w-full text-center uppercase text-[12px] py-2',
            router.pathname === url
              ? 'dark:bg-green-400 bg-primary-150 dark:text-green-900 text-primary-600 dark:border-green-600 border-primary-400'
              : 'dark:border-green-600 border-gray-250 dark:bg-green-900 bg-white_theme-50 dark:text-green-400 text-gray-600',
          )}
        >
          {label}
        </a>
      ))}
    </div>
  );
};

export default LivescoreSidebarTabs;
